import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { BillingKind, IBillingSubscriptionData } from "common/records/BillingSubscription";
import { Nullable } from "common/types";

export const RECEIVE_BILLING_SUBSCRIPTIONS = "@billing/RECEIVE_BILLING_SUBSCRIPTIONS";
export const SET_SESSION_URL = "@billing/SET_SESSION_URL";
export const SET_BILLING_LOADING = "@billing/SET_BILLING_LOADING";
export const SET_BILLING_KIND = "@billing/SET_BILLING_KIND";

export const BillingActions = {
  receiveBillingSubscriptions: (orgId: number, subscriptions: IBillingSubscriptionData[]) =>
    createAction(RECEIVE_BILLING_SUBSCRIPTIONS, { orgId, subscriptions }),
  setSessionUrl: (url: Nullable<string>) => createAction(SET_SESSION_URL, { url }),
  setBillingLoading: (loading: boolean) => createAction(SET_BILLING_LOADING, { loading }),
  setBillingKind: (kind: BillingKind) => createAction(SET_BILLING_KIND, { kind }),
};

export type BillingActions = ActionsUnion<typeof BillingActions>;
